<!--eslint-disable-->
<template>
  <div class="addMarketing f16">
    <div class="lin_75 f18 gray_9 fb">
      营销策略 -
      <span class="gray_2" v-if="this.strategy === 'DIRECT'">手动发放</span>
      <span class="gray_2" v-if="this.strategy === 'STRATEGY'">策略发放</span>
    </div>
    <div class="b_white ps_main">
      <p class="ps_main_head">温馨提示：为保障优惠券成功发放至用户账户，请保证优惠券发放数量充足</p>
      <div class="clear ps_search_wrap" v-if="this.strategy === 'STRATEGY'">
        <span class="float-left marketing_head">营销策略名称</span>
        <div class="ps_search float-left">
          <el-input
            type="text"
            placeholder="请输入营销策略名称"
            maxlength="10"
            show-word-limit
            v-model="shopMarketing.marketingName"
          >
          </el-input>
        </div>
      </div>
      <div class="clear flex">
        <span class="float-left marketing_head">营销客户</span>
        <div class="float-left client_list">
          <div class="lin_30" v-if="this.strategy === 'STRATEGY'">
            <el-radio-group v-model="shopMarketing.customerType" @change="changeCustomerType">
              <el-radio label='GROUPING'>按客户分组</el-radio>
              <el-radio label='CUSTOMER'>按指定客户</el-radio>
              <el-radio label='ALL'>所有人群</el-radio>
            </el-radio-group>
          </div>
          <div class="lin_30" v-if="this.strategy === 'DIRECT'">
            <el-radio-group v-model="shopMarketing.customerType" @change="changeCustomerType">
              <el-radio label='GROUPING'>按客户分组</el-radio>
              <el-radio label='CUSTOMER'>按指定客户</el-radio>
            </el-radio-group>
          </div>
          <ul class="clear" v-show="shopMarketing.customerType === 'GROUPING'">
            <el-checkbox-group v-model="checkGroupList" size="small" @change="changeGroup" class="flex flex_wrap">
              <el-checkbox
                class="mar15_t"
                :label="group"
                border
                v-for="group in customerGroupList" v-bind:key="group.id">
                {{group.name}}
              </el-checkbox>
            </el-checkbox-group>
          </ul>
          <ul class="clear pad15_t" v-show="shopMarketing.customerType === 'CUSTOMER'">
            <el-button type="primary" class="mar10_l" @click="openCustomerPop()">添加</el-button>
            <div class="box20"></div>
            <el-table :data="customerPop.customerSelList" style="width: 100%">
              <el-table-column prop="name" label="客户名称" width="300"> </el-table-column>
              <el-table-column prop="phone" width="260" label="联系电话"> </el-table-column>
              <el-table-column prop="groupName" label="分组名称"> </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="red cursor" @click="removeSelectCustomer(scope.row)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </ul>
        </div>
      </div>
      <div class="clear">
        <span class="float-left marketing_head">营销类型</span>
        <div class="float-left coupon_list">
          <p class="f14 lin_30">
            <span class="pad20_r">优惠券</span>
            <span class="c_blue cursor" @click="chooseCoupon">添加</span>
          </p>
          <div class="box10"></div>
          <ul class="clear f12 white">
            <li v-for="(coupon,index) in checkCouponList" v-bind:key="coupon.regCode">
              <div class="coupon_delete" @click="removeCheckCoupon(index)">
                <i class="iconfont icon-iconfontshibai red f15"></i>
              </div>
              <div class="clear coupon_price">
                <span class="float-left f24">￥{{coupon.regVal}}</span>
                <div class="float-right t_right">
                  <p>满{{coupon.regKey}}元可用</p>
                  <p v-if="coupon.busType === 'SHOP'">全部货品可用</p>
                  <p v-if="coupon.busType === 'GOODS'">指定货品可用</p>
                  <p v-if="coupon.busType === 'CATE'">指定分类可用</p>
                </div>
              </div>
              <p class="t_center">领取时间：{{coupon.startTimeStr}}至{{coupon.endTimeStr}}</p>
              <p class="t_center">使用时间：{{coupon.useStartTimeStr}}至{{coupon.useEndTimeStr}}</p>
              <div class="clear coupon_num gray_3">
                <span class="float-left">数量：<em class="red">{{coupon.surplusNum}}</em></span>
                <span class="float-right" v-if="coupon.residueEndDay">即将到期</span>
              </div>
              <p class="f14" style="color: black" v-if="shopMarketing.customerType === 'GROUPING' && coupon.surplusNum < checkGroupMemberNum">
                优惠券数量小于分组总人数（{{checkGroupMemberNum}}）</p>
              <p class="f14" style="color: black" v-if="shopMarketing.customerType === 'GROUPING' && coupon.surplusNum >= checkGroupMemberNum">
                分组总人数（{{checkGroupMemberNum}}）</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="clear mar30_b" v-if="this.strategy === 'DIRECT'">
        <span class="float-left marketing_head">发放</span>
        <div class="float-left f14">
          <p class="lin_30">直接发放至用户的账户</p>
        </div>
      </div>
      <div class="clear condition_set mar30_b" v-if="this.strategy === 'STRATEGY'">
        <span class="float-left marketing_head">条件设置</span>
        <div class="float-left f14">
          <div>
            <el-radio-group class="radio-block" @change="strategyChange" v-model="strategyType">
              <el-radio label="ORDER_AMOUNT">
                <span>根据金额发放</span>
                <template v-if="shopMarketing.strategyCondition === 'ORDER_AMOUNT' && shopMarketing.strategyRule !== 'TOTAL'">
                  <span class="mar20-l gray6">
                  一笔订单，金额满
                  <el-input-number v-model="shopMarketing.operatorAmountQuantity" size="mini" :precision="2" :step="1" :min="1"></el-input-number> 元
                </span>
                  <span class="mar20-l gray6">
                  是否开启叠加发放
                  <el-switch
                    class="mar10-l"
                    v-model="shopMarketing.strategyRule"
                    active-value="OVERLAY"
                    inactive-value="ONCE"
                    active-color="#ff0023"
                    inactive-color="#999">
                  </el-switch>
                </span>
                </template>
              </el-radio>
              <el-radio label="ORDER_QUANTITY">
                <span>根据数量发放</span>
                <template v-if="shopMarketing.strategyCondition === 'ORDER_QUANTITY' && shopMarketing.strategyRule !== 'TOTAL'">
                  <span class="mar20-l gray6">
                  一笔订单，数量满 <el-input-number v-model="shopMarketing.operatorAmountQuantity" size="mini" :precision="2" :step="1" :min="1"></el-input-number> 件
                  </span>
                  <span class="mar20-l gray6">
                    是否开启叠加发放
                    <el-switch
                      class="mar10-l"
                      v-model="shopMarketing.strategyRule"
                      active-value="OVERLAY"
                      inactive-value="ONCE"
                      active-color="#ff0023"
                      inactive-color="#999">
                    </el-switch>
                  </span>
                </template>
              </el-radio>
              <el-radio label="TOTAL">累计发放</el-radio>
            </el-radio-group>
            <el-radio-group v-if="shopMarketing.strategyRule === 'TOTAL'" v-model="strategyTotalType" class="radio-block mar30-l" @change="strategyTotalChange">
              <el-radio label="ORDER_AMOUNT">
                <span>按照消费金额</span>
                <span class="mar20-l gray6">
                  有效期内累计消费满 <el-input-number v-model="shopMarketing.operatorAmountQuantity" size="mini" :precision="2" :step="1" :min="1"></el-input-number> 元
                </span>
              </el-radio>
              <el-radio label="ORDER_QUANTITY">
                <span>按商品发放</span>
                <span class="mar20-l gray6">
                  有效期内累计商品交易 <el-input-number v-model="shopMarketing.operatorAmountQuantity" size="mini" :precision="2" :step="1" :min="1"></el-input-number> 件
                </span>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="lin_30">
            <el-radio-group v-model="shopMarketing.strategyGoods">
              <el-radio label="ALL">全部货品</el-radio>
              <el-radio label="APPOINT">指定货品</el-radio>
            </el-radio-group>
            <span v-show="shopMarketing.strategyGoods === 'APPOINT'" class="pad15_l c_blue cursor" @click="selectGoodsList('GOODS')">添加货品</span>
            <span v-show="shopMarketing.strategyGoods === 'APPOINT'" class="pad15_l c_blue cursor" @click="selectGoodsList('DEALER')">添加代销货品</span>
          </div>
          <div v-show="shopMarketing.strategyGoods === 'APPOINT'">
            <el-table :data="checkGoodsList" style="width: 100%">
              <el-table-column prop="name" label="商品名称" width="300"> </el-table-column>
              <el-table-column prop="marketPriceStr" width="260" label="价格"> </el-table-column>
              <el-table-column prop="statusName" label="状态"> </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="red cursor" @click="removeCheckGoods(scope.row.goodsId)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="clear pad100-l mar30-l mar30_b" v-if="this.strategy === 'STRATEGY'">
        <span class="float-left">有效期：</span>
        <div class="float-left f14">
          <el-date-picker
            v-model="selectDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
      </div>
      <div class="clear flex" v-if="this.strategy === 'STRATEGY' && this.strategyType != 'TOTAL'">
        <span class="float-left marketing_head">发放方式</span>
        <div class="float-left client_list">
          <div class="lin_30">
            <el-radio-group v-model="shopMarketing.marketingGrantType">
              <el-radio label='1'>支付完成后发放</el-radio>
              <el-radio label='2'>卖家发货后发放</el-radio>
              <el-radio label='3'>确认收货后发放</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="marking_btn">
        <el-button type="primary" @click="submitMarketingBefore">确 认</el-button>
        <router-link to='/mj/marketingList'><el-button>取 消</el-button></router-link>
      </div>
    </div>
    <!--选择商品弹框-->
    <el-dialog
      title="选择商品"
      :visible.sync="chooseGoodVisible"
      :close-on-click-modal="false"
      width="1140px"
      top="80px"
      :show-close="false"
      custom-class="chooseGoodPop">
      <div class="clear ps_search_wrap">
        <span class="float-left pad15_r lin_30 inlineblock">货品名称</span>
        <div class="ps_search float-left">
          <el-input
            type="text"
            placeholder="请输入货品名称"
            v-model="searchGoods.name"
          >
          </el-input>
        </div>
        <div class="float-left client_pop_query" @click="listShopGoods()">搜索</div>
      </div>
      <div class="box30"></div>
      <el-table
        :data="goodsDataList"
        ref="multipleTable"
        @selection-change="goodsDialogSelect"
        row-key="goodsId"
        style="width: 100%"
        height="289"
      >
        <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
        <el-table-column prop="name" label="商品名称" width="400"> </el-table-column>
        <el-table-column prop="marketPriceStr" width="200" label="价格"> </el-table-column>
        <el-table-column prop="shopName" v-if="goodsSelType !== 'GOODS'" label="店铺名称"> </el-table-column>
        <el-table-column prop="statusName" label="状态"> </el-table-column>
      </el-table>
      <div class="box15"></div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goodsDialogConfirm">确 认</el-button>
        <el-button @click="chooseGoodVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--选择优惠券弹框-->
    <el-dialog
      title="选择优惠券"
      :visible.sync="chooseCouponVisible"
      :close-on-click-modal="false"
      width="540px"
      top="120px"
      :show-close="false"
      custom-class="chooseCouponPop">
      <div class="coupon_list">
        <ul class="clear f12 white">
          <li v-for="coupon in shopCouponList"
              v-bind:key="coupon.regCode"
              v-bind:class="{'coupon_check' : coupon.isCheck}"
              v-if="coupon.surplusNum > 0"
              @click="checkCoupon(coupon)">
            <div class="clear coupon_price">
              <span class="float-left f24">￥{{coupon.regVal}}</span>
              <span class="float-left pad5_l lin_35">满{{coupon.regKey}}</span>
            </div>
            <p class="pad20_l f14">有效期至{{coupon.endTimeStr}}</p>
            <div class="box15"></div>
            <div class="clear coupon_num gray_3">
              <span class="float-left" v-if="coupon.busType === 'SHOP'">全部货品可用</span>
              <span class="float-left" v-else-if="coupon.busType === 'GOODS'">指定货品可用</span>
              <span class="float-left" v-else-if="coupon.busType === 'CATE'">指定分类可用</span>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmCheckCoupon">确 定</el-button>
        <el-button @click="chooseCouponVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="confirmDialog"
      width="20%">
      <p>优惠券即将到期或剩余数量小于用户总人数</p>
      <p>请确认是否创建此营销活动</p>
      <span slot="footer" class="dialog-footer">
    <el-button @click="confirmDialog = false">暂不创建</el-button>
    <el-button type="primary" @click="submitMarketing">确定创建</el-button>
  </span>
    </el-dialog>
    <!--选择客户弹框-->
    <el-dialog
      title="选择客户"
      :visible.sync="customerPop.chooseClientVisible"
      :close-on-click-modal="false"
      width="800px"
      :show-close="false"
      custom-class="chooseClientPop"
    >
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock" style="padding-right: 25px">客户名称</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入客户名称" v-model="customerPop.searchCustomer.name"> </el-input>
          </div>
        </div>
        <div class="clear ps_search_wrap" style="padding-top: 10px">
          <span class="float-left pad15_r lin_30 inlineblock" style="padding-right: 11px">客户手机号</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入客户手机号" v-model="customerPop.searchCustomer.phone"> </el-input>
          </div>
          <div class="float-left client_pop_query" @click="listCustomer(1)">搜索</div>
        </div>
        <div class="box30"></div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">客户分组</span>
          <div class="ps_search float-left">
            <el-select v-model="customerPop.searchCustomer.groupId" placeholder="请选择客户分组" clearable>
              <el-option v-for="item in customerGroupList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="box20"></div>
        <div class="clear ps_group_list">
          <div class="float-left client_list_all">
            <p>我的客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <!-- 客户-->
                <li
                  v-for="(item, index) in customerPop.customerDataList"
                  :key="index"
                  @click="customerDialogSelect(item)"
                >
                  <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                  <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p>已选客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <li v-for="(item, index) in customerPop.customerSelList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectCustomer(item)"></i>
                  <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                  <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box20"></div>
      <el-pagination
        background
        @size-change="handleSizeChangeCustomer"
        @current-change="handleCurrentChangeCustomer"
        :current-page="customerPop.currentPageCustomer"
        :page-sizes="[10, 20, 30]"
        :page-size="customerPop.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="customerPop.totalCount"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="customerDialogConfirm">确 认</el-button>
        <el-button @click="customerDialogClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      value: "",
      confirmDialog: false, // 提交弹窗
      strategy: "",
      clientRadio: "ALL", // 营销客户类型
      conditionRadio: 1,
      goodRadio: 1,
      startTime: "",
      endTime: "",
      chooseGoodVisible: false,
      categoryDataList: [], // 店铺分类列表
      chooseCouponVisible: false,
      customerGroupList: [], // 全部客户分组列表
      checkGroupList: [],
      checkGroupMemberNum: 0,
      shopCouponList: [], // 店铺全部优惠券
      checkCouponList: [],
      selectDate: [], // 选择时间
      shopMarketing: {
        marketingName: "",
        marketingCouponJson: "",
        customerType: "ALL",
        customerGroupJson: "",
        marketingStrategy: "", // 直接发放还是策略
        startTime: "",
        endTime: "",
        strategyCondition: "ORDER_AMOUNT", // 条件 金额、数量
        strategyRule: "ONCE",
        operatorAmountQuantity: "", // 金额/数量
        strategyGoods: "ALL", // 商品策略
        strategyGoodsJson: "",
        marketingGrantType: "3",
      },
      goodsSelType: "GOODS",
      strategyType: "ORDER_AMOUNT",
      strategyTotalType: "ORDER_AMOUNT",
      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      goodsDataList: [], // 店铺商品列表
      goodsSelectList: [], // 店铺商品选中列表
      checkGoodsList: [], // 选择的商品
      multipleSelection: [],
      searchGoods: {
        name: "",
        axis: "",
        pageNum: 1,
        pageSize: 10,
        isoa: 0,
        status: "5",
      },
      // 禁用选择当前时间之前
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      customerPop: {
        chooseClientVisible: false,
        searchCustomer: {
          name: "",
          phone: "",
          groupId: "",
          pageNum: 1,
          pageSize: 10,
        },
        customerDataList: [],
        customerSelList: [],
        currentPageCustomer: 1,
        groupDataList: [],
        pageSize: 10,
        totalCount: 0,
      },
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.strategy = this.$route.params.strategy;
    console.log(this.strategy);
    if (this.strategy === "DIRECT") {
      this.$set(this.shopMarketing, "customerType", "GROUPING");
      this.listCustomerGroup();
      this.listShopCoupon();
    } else if (this.strategy === "STRATEGY") {
      this.listShopCoupon();
    } else {
      this.$router.push({
        path: "/mj/marketingList",
      });
    }
  },
  // 进入页面加载数据 -相当于jquery的ready
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    listCustomerGroup() {
      this.$store.dispatch("shop/shop/getCustomerGroupList").then((data) => {
        if (data) {
          this.customerGroupList = data;
        }
      });
    },
    listShopCoupon() {
      this.$store.dispatch("coupon/coupon/getShopCouponList").then((data) => {
        if (data) {
          this.shopCouponList = data;
          this.shopCouponList.forEach((coupon) => {
            this.$set(coupon, "isCheck", false);
          });
        }
      });
    },
    changeCustomerType() {
      if (this.shopMarketing.customerType === "GROUPING" && this.customerGroupList.length === 0) {
        this.listCustomerGroup();
      }
      this.checkGroupList = [];
    },
    // 打开优惠券弹窗
    chooseCoupon() {
      this.shopCouponList.forEach((coupon) => {
        coupon.isCheck = false;
        if (this.checkCouponList.findIndex((c) => c.regCode === coupon.regCode) >= 0) {
          coupon.isCheck = true;
        }
      });
      this.chooseCouponVisible = true;
    },
    // 选择优惠券
    checkCoupon(coupon) {
      this.$set(coupon, "isCheck", !coupon.isCheck);
    },
    // 选中分组
    changeGroup() {
      this.checkGroupMemberNum = 0;
      this.checkGroupList.forEach((group) => {
        this.checkGroupMemberNum += group.customerNum;
      });
    },
    // 确定选择优惠券
    confirmCheckCoupon() {
      this.checkCouponList = [];
      this.shopCouponList.forEach((coupon) => {
        if (coupon.isCheck) {
          this.checkCouponList.push(coupon);
        }
      });
      this.chooseCouponVisible = false;
      console.log(this.checkCouponList);
    },
    strategyChange(value) {
      if (value === "TOTAL") {
        this.$set(this.shopMarketing, "strategyRule", value);
        this.$set(this.shopMarketing, "strategyCondition", "ORDER_AMOUNT");
        return;
      }
      this.$set(this.shopMarketing, "strategyCondition", value);
      this.$set(this.shopMarketing, "strategyRule", "ONCE");
    },
    strategyTotalChange(value) {
      this.$set(this.shopMarketing, "strategyCondition", value);
    },
    // 预提交
    submitMarketingBefore() {
      let confirmFlag = true;
      this.checkCouponList.forEach((coupon) => {
        if (this.shopMarketing.customerType === "GROUPING") {
          if (coupon.residueEndDay || coupon.surplusNum < this.checkGroupMemberNum) {
            confirmFlag = false;
          }
        }
        if (this.shopMarketing.customerType === "CUSTOMER") {
          if (coupon.residueEndDay || coupon.surplusNum < this.checkGroupList.length) {
            confirmFlag = false;
          }
        }
      });
      if (confirmFlag) {
        this.submitMarketing();
      } else {
        this.confirmDialog = true;
      }
    },
    // 提交添加
    // eslint-disable-next-line consistent-return
    submitMarketing() {
      this.confirmDialog = false;
      this.$set(this.shopMarketing, "marketingStrategy", this.strategy);
      const couponList = [];
      let groupList = [];
      const goodsList = [];
      this.checkGroupList.forEach((group) => {
        groupList.push(group.id);
      });
      if (this.shopMarketing.customerType === "CUSTOMER") {
        // eslint-disable-next-line no-const-assign
        groupList = [];
        this.checkGroupList.forEach((group) => {
          groupList.push(group);
        });
      }
      this.checkCouponList.forEach((coupon) => {
        couponList.push(coupon.regCode);
      });
      this.checkGoodsList.forEach((goods) => {
        goodsList.push(goods.goodsId);
      });
      this.$set(this.shopMarketing, "marketingCouponJson", JSON.stringify(couponList));
      this.$set(this.shopMarketing, "customerGroupJson", JSON.stringify(groupList));
      this.$set(this.shopMarketing, "strategyGoodsJson", JSON.stringify(goodsList));
      console.log(this.shopMarketing);
      if (couponList.length === 0) {
        this.$message.error("营销优惠券不能为空");
        return false;
      }
      if (this.strategy === "DIRECT") {
        // 直接发放
        this.$set(this.shopMarketing, "startTime", Date.now());
        this.$set(this.shopMarketing, "endTime", Date.now());
        if (groupList.length === 0) {
          this.$message.error("请选择营销分组");
          return false;
        }
        this.$store.dispatch("shop/shopMarketing/addMarketingDirect", this.shopMarketing).then((res) => {
          if (res.code === "0") {
            this.$message.success("添加营销成功");
            this.$router.push("/mj/marketingList");
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        // 策略发放
        this.$set(this.shopMarketing, "startTime", this.selectDate[0]);
        this.$set(this.shopMarketing, "endTime", this.selectDate[1]);
        if (this.shopMarketing.marketingName === "") {
          this.$message.error("营销策略名称不能为空");
          return false;
        }
        if (this.shopMarketing.customerType === "GROUPING" && groupList.length === 0) {
          this.$message.error("营销分组不能为空");
          return false;
        }
        if (this.shopMarketing.strategyCondition === "" || this.shopMarketing.operatorAmountQuantity === "") {
          this.$message.error("营销条件不能为空");
          return false;
        }
        if (this.shopMarketing.strategyGoods === "APPOINT" && goodsList.length === 0) {
          this.$message.error("营销商品不能为空");
          return false;
        }
        if (this.selectDate.length === 0) {
          this.$message.error("营销时间不能为空");
          return false;
        }
        if (this.strategyType === "TOTAL") {
          this.shopMarketing.marketingGrantType = "3";
        }
        this.$store.dispatch("shop/shopMarketing/addMarketingStrategy", this.shopMarketing).then((res) => {
          if (res.code === "0") {
            this.$message.success("添加营销成功");
            this.$router.push("/mj/marketingList");
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.goodsSelType === "DEALER") {
        this.listDealerGoods();
      } else {
        this.listShopGoods();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.goodsSelType === "DEALER") {
        this.listDealerGoods();
      } else {
        this.listShopGoods();
      }
    },
    // 点击添加货品
    selectGoodsList(type) {
      this.chooseGoodVisible = true;
      this.goodsSelType = type;
      if (type === "DEALER") {
        this.listDealerGoods();
      } else {
        this.listShopGoods();
      }
    },
    // 查询店铺全部在售非oa商品
    listShopGoods() {
      this.searchGoods.pageNum = this.currentPage;
      this.searchGoods.pageSize = this.pageSize;
      this.$store.dispatch("goods/goods/getShopGoodsList", this.searchGoods).then((data) => {
        if (data) {
          this.goodsDataList = data.goodsList;
          this.totalCount = data.totalCount;
          this.toggleSelection(this.checkGoodsList);
        }
      });
    },
    // 查询代销商品
    listDealerGoods() {
      this.searchGoods.pageNum = this.currentPage;
      this.searchGoods.pageSize = this.pageSize;
      this.$store.dispatch("goods/goods/getDealershipsList", this.searchGoods).then((data) => {
        if (data) {
          this.goodsDataList = data.list;
          this.goodsDataList.forEach((goods) => {
            this.$set(goods, "statusName", "出售中");
          });
          this.totalCount = data.totalCount;
          this.toggleSelection(this.checkGoodsList);
        }
      });
    },
    // 商品列表页点击商品
    goodsDialogSelect(val) {
      this.multipleSelection = val;
    },
    // 删除选择商品弹框中已选择商品
    removeSelectGoods(index) {
      this.multipleSelection.splice(index, 1);
    },
    // 确定选择商品
    goodsDialogConfirm() {
      this.checkGoodsList = [];
      this.multipleSelection.forEach((goods) => {
        this.checkGoodsList.push(goods);
      });
      this.chooseGoodVisible = false;
    },
    // 删除已选中商品
    removeCheckGoods(goodsId) {
      this.checkGoodsList.splice(
        this.checkGoodsList.findIndex((item) => item.goodsId === goodsId),
        1
      );
      this.toggleSelection(this.checkGoodsList);
    },
    removeCheckCoupon(index) {
      this.checkCouponList.splice(index, 1);
    },
    toggleSelection(rows) {
      if (!this.$refs.multipleTable) {
        return;
      }
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      }
    },
    openCustomerPop() {
      this.customerPop.currentPageCustomer = 1;
      this.customerPop.chooseClientVisible = true;
      this.listCustomer(1);
    },
    handleSizeChangeCustomer(val) {
      this.customerPop.pageSize = val;
      this.listCustomer();
    },
    handleCurrentChangeCustomer(val) {
      this.customerPop.currentPageCustomer = val;
      this.listCustomer();
    },
    customerDialogClose() {
      this.customerPop.chooseClientVisible = false;
    },
    listCustomer(type) {
      const { searchCustomer } = this.customerPop;
      searchCustomer.pageNum = this.customerPop.currentPageCustomer;
      searchCustomer.pageSize = this.customerPop.pageSize;
      if (type === 1) {
        searchCustomer.pageNum = 1;
      }
      this.$store.dispatch("shop/shop/listCustomer", this.$qs.stringify(searchCustomer)).then((data) => {
        const newData = data || {};
        this.customerPop.customerDataList = newData.data || [];
        this.customerPop.totalCount = newData.count || 0;
        if (type === 2) {
          if (this.customerPop.customerDataList.length === 0) {
            this.$message.error("无客户数据,请添加客户");
            return;
          }
          this.customerPop.chooseClientVisible = true;
        }
      });
    },
    customerDialogSelect(item) {
      if (item.isCheck) {
        return;
      }
      if (this.customerPop.customerSelList.some((e) => e.id === item.id)) {
        console.log(1);
      } else {
        this.checkGroupList.push(item.targetIdStr);
        this.customerPop.customerSelList.push(item);
      }
    },
    removeSelectCustomer(item) {
      this.checkGroupList.splice(this.checkGroupList.indexOf(item.targetIdStr), 1);
      this.customerPop.customerSelList.splice(this.customerPop.customerSelList.indexOf(item), 1);
    },
    customerDialogConfirm() {
      this.customerPop.chooseClientVisible = false;
    },
    getCustomerType() {
      this.checkGroupList = [];
      this.customerPop.customerSelList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
}
@import "index";
</style>
